import { DatePicker, Form } from 'antd';
import React from 'react';
import { getRules } from './util';
// import moment from 'moment';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker,
    DateForm = (props) => {
        let { setting = {}, updated, desc } = props,
            { type, showTime } = setting;
        const disabled = updated !== 0,
            dateForm = () => {
                if (showTime === 1) {
                    return 'YYYY';
                } else if (showTime === 2) {
                    return 'YYYY-MM';
                } else if (showTime === 3) {
                    return 'YYYY-MM-DD';
                }
                return 'YYYY-MM-DD HH:mm:ss';
            },
            showDatePicker = () => {
                if (showTime === 1) {
                    return (
                        <DatePicker
                            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            picker="year"
                            format={'YYYY'}
                        ></DatePicker>
                    );
                } else if (showTime === 2) {
                    return (
                        <DatePicker
                            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            picker="month"
                            format={'YYYY-MM'}
                        ></DatePicker>
                    );
                } else if (showTime === 3) {
                    return (
                        <DatePicker
                            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            format={'YYYY-MM-DD'}
                        ></DatePicker>
                    );
                }
                return (
                    <DatePicker
                        // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        disabled={disabled}
                        style={{ width: '100%' }}
                        showTime
                        format={'YYYY-MM-DD HH:mm:ss'}
                    ></DatePicker>
                );
            },
            showRangePicker = () => {
                if (showTime === 1) {
                    return (
                        <RangePicker
                            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            picker="year"
                            format={'YYYY'}
                            separator={'至'}
                        ></RangePicker>
                    );
                } else if (showTime === 2) {
                    return (
                        <RangePicker
                            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            picker="month"
                            format={'YYYY-MM'}
                            separator={'至'}
                        ></RangePicker>
                    );
                } else if (showTime === 3) {
                    return (
                        <RangePicker
                            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            format={'YYYY-MM-DD'}
                            separator={'至'}
                        ></RangePicker>
                    );
                }
                return (
                    <RangePicker
                        // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        disabled={disabled}
                        style={{ width: '100%' }}
                        showTime
                        format={'YYYY-MM-DD HH:mm:ss'}
                        separator={'至'}
                    ></RangePicker>
                );
            };

        return (
            //isComplete为true 是大赛引入 大赛引入getValueFromEvent getValueProps 如果有 影响编辑反显 不全部改怕影响其他业务使用
            props?.isComplete ? (
                type === 'range' ? (
                    <>
                        {desc ? (
                            <div className={'grt-dynamic-picker-warp'}>
                                <Form.Item
                                    key={props.field_id}
                                    label={props.label === undefined ? props.name : props.label}
                                    name={props.en_name}
                                    rules={getRules(props)}
                                >
                                    {showRangePicker()}
                                </Form.Item>
                                <div className={'grt-dynamic-picker-desc'}>
                                    <div class={'main-col-' + props.labelCol.span}>&nbsp;</div>
                                    <div class={'main-col-' + props.wrapperCol.span}>
                                        <ExclamationCircleOutlined style={{ marginRight: 5 }} />
                                        {desc}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Form.Item
                                key={props.field_id}
                                label={props.label === undefined ? props.name : props.label}
                                name={props.en_name}
                                rules={getRules(props)}
                            >
                                {showRangePicker()}
                            </Form.Item>
                        )}
                    </>
                ) : (
                    <>
                        {desc ? (
                            <div className={'grt-dynamic-picker-warp'}>
                                <Form.Item
                                    key={props.field_id}
                                    label={props.label === undefined ? props.name : props.label}
                                    name={props.en_name}
                                    rules={getRules(props)}
                                >
                                    {showDatePicker()}
                                </Form.Item>
                                <div className={'grt-dynamic-picker-desc'}>
                                    <div class={'main-col-' + props.labelCol.span}>&nbsp;</div>
                                    <div class={'main-col-' + props.wrapperCol.span}>
                                        <ExclamationCircleOutlined style={{ marginRight: 5 }} />
                                        {desc}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Form.Item
                                key={props.field_id}
                                label={props.label === undefined ? props.name : props.label}
                                name={props.en_name}
                                rules={getRules(props)}
                            >
                                {showDatePicker()}
                            </Form.Item>
                        )}
                    </>
                )
            ) : type === 'range' ? (
                <>
                    {desc ? (
                        <div className={'grt-dynamic-picker-warp'}>
                            <Form.Item
                                key={props.field_id}
                                label={props.label === undefined ? props.name : props.label}
                                name={props.en_name}
                                rules={getRules(props)}
                                getValueFromEvent={(data) => {
                                    const value = data && data.length > 0 && data.map((item) => dayjs(item).format(dateForm()));
                                    return value;
                                }}
                                getValueProps={(data) => {
                                    const value = data && data.length > 0 && data.map((item) => dayjs(item).format(dateForm()));
                                    return value;
                                }}
                            >
                                {showRangePicker()}
                            </Form.Item>
                            <div className={'grt-dynamic-picker-desc'}>
                                <div class={'main-col-' + props.labelCol.span}>&nbsp;</div>
                                <div class={'main-col-' + props.wrapperCol.span}>
                                    <ExclamationCircleOutlined style={{ marginRight: 5 }} />
                                    {desc}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Form.Item
                            key={props.field_id}
                            label={props.label === undefined ? props.name : props.label}
                            name={props.en_name}
                            rules={getRules(props)}
                            getValueFromEvent={(data) => {
                                const value = data && data.length > 0 && data.map((item) => dayjs(item).format(dateForm()));
                                return value;
                            }}
                            getValueProps={(data) => {
                                const value = data && data.length > 0 && data.map((item) => dayjs(item).format(dateForm()));
                                return value;
                            }}
                        >
                            {showRangePicker()}
                        </Form.Item>
                    )}
                </>
            ) : (
                <>
                    {desc ? (
                        <div className={'grt-dynamic-picker-warp'}>
                            <Form.Item
                                key={props.field_id}
                                label={props.label === undefined ? props.name : props.label}
                                name={props.en_name}
                                rules={getRules(props)}
                                getValueFromEvent={(data) => {
                                    return dayjs(data).format(dateForm());
                                }}
                                getValueProps={(data) => {
                                    return dayjs(data).format(dateForm());
                                }}
                            >
                                {showDatePicker()}
                            </Form.Item>
                            <div className={'grt-dynamic-picker-desc'}>
                                <div class={'main-col-' + props.labelCol.span}>&nbsp;</div>
                                <div class={'main-col-' + props.wrapperCol.span}>
                                    <ExclamationCircleOutlined style={{ marginRight: 5 }} />
                                    {desc}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Form.Item
                            key={props.field_id}
                            label={props.label === undefined ? props.name : props.label}
                            name={props.en_name}
                            rules={getRules(props)}
                            getValueFromEvent={(data) => {
                                return dayjs(data).format(dateForm());
                            }}
                            getValueProps={(data) => {
                                return dayjs(data).format(dateForm());
                            }}
                        >
                            {showDatePicker()}
                        </Form.Item>
                    )}
                </>
            )
        );
    };

export default DateForm;

// <Form.Item key={props.field_id} label={props.label === undefined ? props.name : props.label}
//     name={props.en_name} rules={getRules(props)}
//     getValueFromEvent={(e)=>{
//         return moment(e).format(datePicker());
//     }}
//     getValueProps={(e) => {
//         return moment(e).format(datePicker());
//     }}
// >
//     {
//         type === 'range' ? showRangePicker() : showDatePicker()
//     }
// </Form.Item>
